import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class GetCoupons extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Get Coupons</h1>
				<p>This method retrieves a list of coupons you received or created.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> GET </td>
							<td> /coupons </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> direction </td>
							<td> String </td>
							<td> Y </td>
							<td> The direction of the coupon to get. Acceptable values are:<br/>- "out": Gets created coupons (default)<br/>- "in": Gets received coupons  </td>
						</tr>
						<tr>
							<td> status </td>
							<td> String </td>
							<td> Y </td>
							<td> The status of the store inventory to include or exclude<br/>- Available values are: <br/>-- "O" : open<br/>-- "S" : redeemed<br/>-- "D" : denied<br/>-- "E" : expired<br/>- If you don't specify this value, this method retrieves coupons in any status<br/>- You can pass a comma-separated string to specify multiple status to include/exclude<br/>- You can add a minus( - ) sign to specify a status to exclude </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns a list of the the <a href="?page=resource-representations-coupon">coupon resource</a> as "data" in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>
						GET /coupons
						<ul>
							<li>Retrieves a list of created coupons</li>
						</ul>
					</li>
					<li>
						GET /coupons?direction=in
						<ul>
							<li>Retrieves a list of received coupons</li>
						</ul>
					</li>
					<li>
						GET /coupons?status=-E
						<ul>
							<li>Retrieves a list of store inventories not in EXPIRED status</li>
						</ul>
					</li>
					<li>
						GET /coupons?status=O
						<ul>
							<li>Retrieves a list of coupons in OPEN status</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}